import React from 'react';
import {Route, Routes} from 'react-router-dom';
import W from "../page/WrapperCMain";
import UrlPage from "../UrlPage";
import PageNotFound from "../page/PageNotFound";
import urlPage from "../UrlPage";

/* amplify ************************* */
import {Amplify} from 'aws-amplify';
import {  Authenticator} from '@aws-amplify/ui-react';

import './app.css';
import '@aws-amplify/ui-react/styles.css';
import awsExports from '../aws-exports';
/* amplify ************************ */

import Home from "../cmain/home/Home";
import EseIndex from "../cmain/ese-index/EseIndex";

Amplify.configure(awsExports);



const pagesList = [
  {
    url: UrlPage.home,
    label: "Inicio",
    f: () => <Home />
  },
  {
    url: UrlPage.estudios,
    label: "Estudios",
    f: () => <EseIndex />
  }
]


const formFields = {
  signIn: {
    username: {
      placeholder: 'Ingresa tu email:',
    },
    password: {
      placeholder: 'Ingresa tu password:',
    },
  },
  forceNewPassword: {
    password: {
      placeholder: 'Ingresa tu password:',
    },
  },
  forgotPassword: {
    username: {
      placeholder: 'Enter your email:',
    },
  },
  confirmResetPassword: {
    confirmation_code: {
      placeholder: 'Ingresa tu código de confirmación:',
      label: 'New Label',
      isRequired: false,
    },
    confirm_password: {
      placeholder: 'Ingresa tu password:',
    },
  },
  setupTotp: {
    QR: {
      totpIssuer: 'test issuer',
      totpUsername: 'amplify_qr_test_user',
    },
    confirmation_code: {
      label: 'New Label',
      placeholder: 'Ingresa tu código de confirmación:',
      isRequired: false,
    },
  },
  confirmSignIn: {
    confirmation_code: {
      label: 'New Label',
      placeholder: 'Ingresa tu código de confirmación:',
      isRequired: false,
    },
  },
};


function AppRouter() {
  
  const elemList = pagesList.map(k => {
    return <Route path={k.url} exact
                  key={k.url}
                  element={<W titulo={k.label} urlPage={k.url}>{k.f()}</W>}/>
    
  })
  
  return (
    
    <Authenticator
      formFields={formFields}
      hideSignUp={true}
    >
      <Routes>
        {/*PAges ************************************** */}
        {elemList}
        <Route path="*" element={<PageNotFound/>}/>
      </Routes>
    
    </Authenticator>
  
  );
}


export default AppRouter;